import { useEffect, useState } from 'react';

/** Under 900 px: a phone or a tablet (the menu is a row of icons, help a full-screen sheet). Keep in step with styles.css. */
export const NARROW_QUERY = '(max-width: 899.98px)';

/**
 * Under 600 px: a phone (rule 8 of docs/specs/ui-layout-rules.md; decision 1030): the menu is a drawer opened from the
 * top bar's "Menu" button, and a row of more than five tabs is a "Section" list. Keep in step with styles.css.
 */
export const PHONE_QUERY = '(max-width: 599.98px)';

function matchesNow(query: string): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : false; // jsdom has no matchMedia: treated as a desktop
}

/** True while the window matches `query`, following it as the window changes. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => matchesNow(query));
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(query);
    const on = (): void => setMatches(mq.matches);
    on();
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, [query]);
  return matches;
}
